import React, { useState, useEffect } from 'react';
import HeaderCardNew from '../../Components/HeaderCardNew';
import FlexibleCard from '../../Components/FlexibleCard';
import RealStoriesCard from '../../Components/RealStoriesCard';
import FeedbackCard from '../../Components/FeedbackCard';
import BannerCard from '../../Components/BannerCard';
import TopNavBarNew from "../../Components/TopNavBarNew";
import BottomNavBarNew from "../../Components/BottomNavBarNew";
import styles from './RealStories.module.css';

export default function RealStoriesTwo({ appLanguage }) {
  const [pageState, setPageState] = useState({
    // General Content
    headerTitle: '',
    extraText: '',
    extraText2: '',

    // Individual Large Cards
    largeCard1: {},

    // Small Cards Section
    smallCardTitle1: '',
    smallCardDescription1: '',
    smallCardTitle2: '',
    smallCardDescription2: '',
    smallCardTitle3: '',
    smallCardDescription3: '',

        // Banner Card
        bannerCardDescription1: '',
        bannerCardTitle1: '',


    // Assets
    headerImage: '',
    arrowIconDark: '',
    heartIcon: '',
    image1: '',
    image2: '',
    image3: '',
    image4: '',
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Real Stories Two';

    const entries = JSON.parse(localStorage.getItem('ayaAppEntries') || '[]');
    const assets = JSON.parse(localStorage.getItem('ayaAppAssets') || '[]');

    const getEntryById = (id) => entries.find((e) => e.sys.id === id);
    const getField = (entry, field, locale) =>
      entry?.fields?.[field]?.[locale] || entry?.fields?.[field]?.['en'] || '';

    const getAssetUrlById = (id, locale) => {
      const asset = assets.find((a) => a.sys.id === id);
      const file = asset?.fields?.file?.[locale] || Object.values(asset?.fields?.file || {})[0];
      if (!file?.url) return '';
      return file.url.startsWith('//') ? `https:${file.url}` : file.url;
    };

    const abortionEntry = getEntryById('7uUpsqYtSADfGrSi4n9qSK');
    const largeCardEntry = getEntryById('7958CFGdsGIXP1YSZVYeN8');

    setPageState({
      headerTitle: getField(abortionEntry, 'headerTitle', appLanguage),
      extraText: getField(abortionEntry, 'extraText', appLanguage),
      extraText2: getField(abortionEntry, 'extraText2', appLanguage),

      smallCardTitle1: getField(abortionEntry, 'smallCardTitle1', appLanguage),
      smallCardDescription1: getField(abortionEntry, 'smallCardDescription1', appLanguage),
      smallCardTitle2: getField(abortionEntry, 'smallCardTitle2', appLanguage),
      smallCardDescription2: getField(abortionEntry, 'smallCardDescription2', appLanguage),
      smallCardTitle3: getField(abortionEntry, 'smallCardTitle3', appLanguage),
      smallCardDescription3: getField(abortionEntry, 'smallCardDescription3', appLanguage),
      smallCardTitle4: getField(abortionEntry, 'smallCardTitle4', appLanguage),
      smallCardDescription4: getField(abortionEntry, 'smallCardDescription4', appLanguage),

      bannerCardTitle1: getField(abortionEntry, 'bannerCardTitle1', appLanguage),
      bannerCardDescription1: getField(abortionEntry, 'bannerCardDescription1', appLanguage),

      largeCard1: {
        blackTitle: getField(largeCardEntry, 'largeCardTitle1', appLanguage),
        description: getField(largeCardEntry, 'largeCardDescription1', appLanguage),
      },

      headerImage: getAssetUrlById('2QqrfQvbM7wiJKDebz76V2', appLanguage),
      arrowIconDark: getAssetUrlById('35s9SZBtTGy9KGs0lc41lt', appLanguage),
      heartIcon: getAssetUrlById('740H3V1s40GxiaZiqj79MY', appLanguage),
      image1: getAssetUrlById('y3Rd7KceR170l23wC9ZX9', appLanguage),
      image2: getAssetUrlById('vOXgrGXEMSZUSsfvgBHl9', appLanguage),
      image3: getAssetUrlById('4fmbucUjI0K41fe3F9Glvy', appLanguage),
      image4: getAssetUrlById('347Kd8twz9RPwSicZyEJwF', appLanguage),
      image5: '',
    });
  }, [appLanguage]);

  return (
    <div className={styles.homePageContainer}>
      <TopNavBarNew backgroundColor="#4350E6" breadcrumbColor="#fff" />
      <div className={styles.libraryAbortionMenuContainer}>
        {/* Header Section */}
        <div className={styles.headerContainer}>
          <HeaderCardNew
            title={pageState.headerTitle}
            image={pageState.headerImage}
            backgroundColor="#4350E6"
            borderRadius="0px"
            titleColor="#fff"
          />
        </div>

        <div className={styles.bottomSpaceHeader}></div>
        {/* Render Individual Large Cards */}
        <FlexibleCard
        blackTitle={pageState.largeCard1.blackTitle}
        titleColor="#4350E6"
          description={pageState.largeCard1.description}
          width="351px"
          borderRadius="10px"
        />

        <BannerCard 
        title={pageState.bannerCardTitle1} 
        description={pageState.bannerCardDescription1}
        image={pageState.image1}
        gradient="linear-gradient(99deg, #4450E5 22.9%, #616CEE 77.43%)"
        link="/chat-main"
        imageWidth="81px"
        imageHeight="80px"
        imagePosition="top-right"
        imageOffsetY=""
        imageOffsetX=""
        titleMaxWidth="256px"
        descriptionMaxWidth="286px"
        cardWidth="349px"
        cardHeight="88px"
        />

        <div className={styles.bottomSpaceHeader}></div>

        {/* Feedback Card Section */}
        <FeedbackCard title={pageState.extraText} appLanguage={appLanguage} />


        <div className={styles.bottomSpaceHeader}></div>

        <div className={styles.leftAlignWrapper}>
        {/* Extra Text Section */}
        <div className={styles.extraTitleTwo}>{pageState.extraText2}</div>
        </div>

        <div className={styles.realStoriesContainer}>
      <RealStoriesCard
        title={pageState.smallCardTitle1}
        isLink={true}
        buttonLink="/real-stories-one"
        description={pageState.smallCardDescription1}
        image={pageState.image2}
        icon={pageState.arrowIconDark}  // Arrow icon path or use pageState.arrowIcon
        backgroundColor="#FDE8D8"
      />
      <RealStoriesCard
        title={pageState.smallCardTitle2}
        isLink={true}
        buttonLink="/real-stories-three"
        description={pageState.smallCardDescription1}
        image={pageState.image3}
        icon={pageState.arrowIconDark}   // Arrow icon path or use pageState.arrowIcon
        backgroundColor="#B4BCFF"
      />
      <RealStoriesCard
        title={pageState.smallCardTitle3}
        isLink={true}
        buttonLink="/real-stories-four"
        description={pageState.smallCardDescription1}
        image={pageState.image4}
        icon={pageState.arrowIconDark}   // Arrow icon path or use pageState.arrowIcon
        backgroundColor="#DAF0FF"
      />
    </div>

      </div>
      <div className={styles.bottomSpace}></div>
      <BottomNavBarNew appLanguage={appLanguage}/>
    </div>
  );
}
